export const FETCH_ALL_PLANS = "FETCH_ALL_PLANS"
export const FETCH_HOMEPAGE_PLANS = "FETCH_HOMEPAGE_PLANS"
export const CURRENT_PLAN = "CURRENT_PLAN"
export const LOAD_USER = "LOAD_USER"
export const FETCH_TRANSACTION = "FETCH_TRANSACTION"
export const GET_NOTES = "GET_NOTES"
export const GLOBAL_UPDATE = "GLOBAL_UPDATE"
export const UPDATE_STATUS = "UPDATE_STATUS"
export const UPDATE_USER = "UPDATE_USER"
export const FETCH_ALL_PLANS_KIDS = "FETCH_ALL_PLANS_KIDS"
export const FETCH_ALL_PLANS_IELTS = "FETCH_ALL_PLANS_IELTS"
